<template>
  <video
    ref="videoPreview"
    data-test-id="PreviewVideo"
    class="preview-video"
    :class="{ 'preview-video--mirrored': mirrored }"
    muted="true"
    autoplay
    playsinline
    data-sentry-block
    @loadeddata="$emit('loaded')"
  />
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watchEffect } from 'vue'

export default defineComponent({
  props: {
    stream: {
      type: Object as PropType<MediaStream | undefined>,
      default: undefined,
    },
    mirrored: {
      type: Boolean,
      default: true,
    },
  },
  emits: {
    loaded: () => true,
  },
  setup(props) {
    const videoPreview = ref<HTMLVideoElement | null>(null)
    watchEffect(() => {
      if (!videoPreview.value) {
        return
      }
      videoPreview.value.srcObject = props.stream ?? null
    })

    return {
      videoPreview,
    }
  },
})
</script>

<style lang="postcss">
.preview-video {
  display: block;
  height: 100%;
  margin: auto;

  @media (orientation: landscape) {
    width: 100%;
  }

  @media (orientation: portrait) {
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
}

video.preview-video--mirrored {
  transform: scaleX(-1);
}
</style>
